'use strict';

exports.__esModule = true;

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container =
/*#__PURE__*/
(0, _reactEmotion2.default)('div', {
  target: 'e1nzkzy80'
})(function (_ref) {
  var theme = _ref.theme;
  return theme.component;
}, ';');
exports.default = Container;